import env from '@/config/env'

const init = (items) => {
  const wrap = document.createElement('div')
  wrap.style.width = '0px'
  wrap.style.height = '0px'
  wrap.style.overflow = 'hidden'
  document.body.appendChild(wrap)
  items.forEach(item => {
    const iframe = document.createElement('iframe')
    iframe.src = env.publishHost.replace(/\/$/, '') + item
    wrap.appendChild(iframe)
  })
}

init(['/old/', '/xmk/'])
